// extracted by mini-css-extract-plugin
export var active = "styles-module--active--0f98f";
export var currentLanguage = "styles-module--currentLanguage--4fc54";
export var header = "styles-module--header--9de12";
export var language = "styles-module--language--90b3b";
export var languagePicker = "styles-module--languagePicker--f20fb";
export var languages = "styles-module--languages--ebfe5";